export const USER_IDENTITY_SLICE_NAME = 'gygUserIdentities'

export const GET_USER_IDENTITY_BY_USER_ID_ACTION = `${USER_IDENTITY_SLICE_NAME}/getUserIdentityByUserId`
export const GET_USER_IDENTITY_GROUP_BY_PROVIDER_ACTION = `${USER_IDENTITY_SLICE_NAME}/getUserIdentitiesGroupByIdentityProvider`
export const GET_USER_IDENTITY_GROUP_BY_PROVIDER_AND_DAY_LAST_30_DAYS_ACTION = `${USER_IDENTITY_SLICE_NAME}/getUserIdentitiesGroupByIdentityProviderAndDayLast30Days`
export const GET_ACCOUNT_DELETION_LAST_30_DAYS_ACTION = `${USER_IDENTITY_SLICE_NAME}/getDeletionStatsLast30Days`
